import React from "react";
import "./SellerTerms.css"; 

export default function SellerTerms() {
  return (
    <div className="terms-page container pt-5 mb-5 pb-5 " style={{marginTop:"120px"}} dir="rtl">
      <h1 className="terms-title mb-4 text-center pt-5 ">الشروط والأحكام</h1>

      <p>
        <strong>الشروط والأحكام لموقع وتطبيق طوق النجاة</strong>
      </p>
      <p>
        مرحبًا بك في موقع وتطبيق <strong>طوق النجاة</strong>، المنصة المتخصصة في
        التسويق الإلكتروني والإعلانات التجارية ودعم المبادرات المجتمعية. باستخدامك
        لخدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام. يرجى قراءتها بعناية
        قبل الاستخدام.
      </p>

      <hr />

      <h5 className="terms-heading">أولًا: التعريف</h5>
      <ul>
        <li>
          <strong>المنصة:</strong> يقصد بها كل من موقع وتطبيق طوق النجاة الإلكتروني.
        </li>
        <li>
          <strong>المستخدم:</strong> هو أي شخص يقوم بتصفح أو استخدام خدمات المنصة بأي
          شكل من الأشكال.
        </li>
      </ul>

      <h5 className="terms-heading">ثانيًا: قبول الشروط</h5>
      <p>
        باستخدامك للمنصة، فإنك تقر بموافقتك الصريحة على هذه الشروط والأحكام.
        <br />
        إذا كنت لا توافق على أي بند منها، يرجى الامتناع عن استخدام خدماتنا.
      </p>

      <h5 className="terms-heading">ثالثًا: الخدمات المقدمة</h5>
      <ol>
        <li>تقديم خدمات تسويق إلكتروني وإعلانات مدفوعة.</li>
        <li>الربط بين التجار والمسوقين بنظام العمولة.</li>
        <li>نشر العروض والخصومات بشكل منظم وآمن.</li>
        <li>دعم المبادرات المجتمعية وتشجيع الأنشطة التطوعية والخيرية.</li>
      </ol>

      <h5 className="terms-heading">رابعًا: التزامات المستخدم</h5>
      <ul>
        <li>يلتزم المستخدم بتقديم بيانات صحيحة ومحدثة أثناء التسجيل.</li>
        <li>الامتناع عن نشر أي محتوى مخالف للأنظمة أو القيم الدينية والمجتمعية.</li>
        <li>يمنع استخدام المنصة في أي أنشطة غير مشروعة أو مسيئة لسمعة طوق النجاة.</li>
      </ul>

      <h5 className="terms-heading">خامسًا: حقوق الملكية الفكرية</h5>
      <p>
        جميع النصوص، الصور، التصاميم، والشعارات المعروضة في المنصة مملوكة لموقع طوق
        النجاة، ويمنع إعادة استخدامها أو نسخها أو تعديلها دون إذن كتابي مسبق من إدارة
        المنصة.
      </p>

      <h5 className="terms-heading">سادسًا: الإعلانات والمسؤولية</h5>
      <p>
        يتحمل المعلن كامل المسؤولية عن دقة وصحة بيانات إعلانه، ويحتفظ الموقع بحق رفض أو
        حذف أي إعلان يخالف القوانين أو سياسة الاستخدام دون إشعار مسبق.
      </p>
      <p>
        كما يتم تحديد نسبة العمولة أو التسويق بناءً على اتفاق مسبق مع إدارة المنصة.
      </p>

      <h5 className="terms-heading">سابعًا: حدود المسؤولية</h5>
      <p>لا يتحمل موقع أو تطبيق طوق النجاة أي مسؤولية عن الأضرار الناتجة عن:</p>
      <ul>
        <li>سوء استخدام الخدمة.</li>
        <li>الأعطال التقنية الخارجة عن الإرادة.</li>
        <li>أي محتوى يُنشر من قبل أطراف خارجية.</li>
      </ul>

      <h5 className="terms-heading">ثامنًا: الخصوصية واستخدام الكوكيز</h5>
      <p>
        تلتزم المنصة بحماية خصوصية المستخدمين وفقًا لسياسة الخصوصية الخاصة بها، وقد
        نستخدم ملفات تعريف الارتباط (Cookies) لتحسين تجربة المستخدم وتقديم خدمات مخصصة
        بشكل أفضل.
      </p>

      <h5 className="terms-heading">تاسعًا: التعديلات على الشروط</h5>
      <p>
        تحتفظ إدارة المنصة بحق تعديل أو تحديث هذه الشروط في أي وقت، ويتم إخطار المستخدمين
        بأي تغييرات جوهرية عبر المنصة أو البريد الإلكتروني المسجل.
      </p>

      <h5 className="terms-heading">عاشرًا: القانون المطبق</h5>
      <p>
        تخضع هذه الشروط والأحكام لأنظمة المملكة العربية السعودية، وأي نزاع ينشأ عنها يُحال
        إلى الجهات القضائية المختصة داخل المملكة.
      </p>

      <hr />

      <p className="terms-footer ">
        © 2025 موقع وتطبيق طوق النجاة – جميع الحقوق محفوظة
      </p>
    </div>
  );
}
